export const adminMessages = {
  kk: {
    platform: {
      title: 'Супер-админ',
      myStore: 'Менің дүкенім',
      logout: 'Шығу',
      ownerOnly: 'Тек иесіне арналған',
      connectedBusinesses: 'Қосылған бизнестер',
      connectedText: 'Тіркелулерді, белсенділікті және дүкендердің толтырылуын бақылаңыз.',
      search: 'Дүкен, иесі немесе e-mail',
      companiesTotal: 'Барлық компаниялар',
      selling: 'Сатылым жасап жатыр',
      productsAdded: 'Қосылған тауарлар',
      totalRevenue: 'Жалпы түсім',
      companies: 'Компаниялар',
      connections: 'қосылу',
      active: 'Белсенді',
      blocked: 'Бұғатталған',
      ownerMissing: 'Иесі көрсетілмеген',
      categories: 'Санаттар',
      products: 'Тауарлар',
      cashiers: 'Кассирлер',
      sales: 'Сатылымдар',
      revenue: 'Түсім',
      quick: 'Жылдам сату',
      catalog: 'Тауарлар бойынша',
      connected: 'Қосылды',
      lastSale: 'Соңғы сатылым:',
      noSales: 'Әзірге сатылым жоқ',
      noCompanies: 'Әзірге қосылулар жоқ',
      companiesNotFound: 'Компаниялар табылмады',
      changeQuery: 'Басқа сұрауды қолданып көріңіз',
      noConnectionsText: 'Мұнда жаңа тіркелген дүкендер пайда болады',
    },
  },
  ru: {
    platform: {
      title: 'Супер-админка',
      myStore: 'Мой магазин',
      logout: 'Выйти',
      ownerOnly: 'Только для владельца',
      connectedBusinesses: 'Подключённые бизнесы',
      connectedText: 'Контролируйте регистрации, активность и наполнение магазинов.',
      search: 'Магазин, владелец или e-mail',
      companiesTotal: 'Всего компаний',
      selling: 'Уже продают',
      productsAdded: 'Товаров добавлено',
      totalRevenue: 'Общая выручка',
      companies: 'Компании',
      connections: 'подключений',
      active: 'Активна',
      blocked: 'Заблокирована',
      ownerMissing: 'Владелец не указан',
      categories: 'Категории',
      products: 'Товары',
      cashiers: 'Кассиры',
      sales: 'Продажи',
      revenue: 'Выручка',
      quick: 'Быстрая продажа',
      catalog: 'По товарам',
      connected: 'Подключён',
      lastSale: 'Последняя продажа:',
      noSales: 'Продаж пока нет',
      noCompanies: 'Подключений пока нет',
      companiesNotFound: 'Компании не найдены',
      changeQuery: 'Попробуйте другой запрос',
      noConnectionsText: 'Здесь появятся новые зарегистрированные магазины',
    },
  },
}
